import './index.css'

interface InputLabelProps {
  label: string,
  placeholder?: string,
  name?: string,
  value: any,
  onChange?: (event: any) => void,
  disabled?: boolean,
  required?: boolean,
  error?: boolean,
  type?: 'string' | 'number'
}

export default function InputLabel({ label, name, value, placeholder, onChange,
  disabled, required, error, type }: InputLabelProps) {

  return (<>
    <div className="input-label-box">
      <label className='input-label__label'>
        {label} {required ? " * " : ""}
        <span className="input-label__error-message">{(required && error) ? "campo requerido" : ''}</span>
      </label>
      <div className='input-label__field'>
        <input
          className={`input-label__input${error ? '__error' : ''}`}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
          type={type}
          min={0}
          pattern="\d*"
          step={1}
        />
      </div>
    </div>
  </>);
}
